var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdrawRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "withdraw-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6L7 10",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6L11 16",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10L11 6",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#withdraw-mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11C1.25 12.2804 1.50219 13.5482 1.99217 14.7312C2.48216 15.9141 3.20034 16.9889 4.10571 17.8943C5.01108 18.7997 6.08591 19.5178 7.26884 20.0078C8.45176 20.4978 9.71961 20.75 11 20.75C12.2804 20.75 13.5482 20.4978 14.7312 20.0078C15.9141 19.5178 16.9889 18.7997 17.8943 17.8943C18.7997 16.9889 19.5178 15.9141 20.0078 14.7312C20.4978 13.5482 20.75 12.2804 20.75 11C20.75 9.71961 20.4978 8.45176 20.0078 7.26884C19.5178 6.08591 18.7997 5.01108 17.8943 4.10571C16.9889 3.20034 15.9141 2.48216 14.7312 1.99217C13.5482 1.50219 12.2804 1.25 11 1.25C9.71961 1.25 8.45176 1.50219 7.26884 1.99217C6.08591 2.48216 5.01108 3.20034 4.10571 4.10571C3.20034 5.01108 2.48216 6.08591 1.99217 7.26884C1.50219 8.45176 1.25 9.71961 1.25 11Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawRounded);
export default __webpack_public_path__ + "static/media/withdraw-rounded.9d426a183a7cef621b67200d4c631da2.svg";
export { ForwardRef as ReactComponent };